import { useDesignEditorStateContext } from "../contexts/design-editor-state-provider.context";
import { useState } from "react";
import { DesignEditorStates } from "../models/enums/design-editor-states.enum";
import { NumberPlaceholderLogoCreate_VM } from "../components/panel/number-placeholder-logo-create.component";
import { useDesignContext } from "../contexts/design.context";
import { useLogoActionHandler } from "../../logo-list/hooks/useLogoActionsHandler";
import { useLogoRepository } from "../../../../data/repositories/LogoRepository";
import {
  Color,
  Font,
  TransferMethod,
} from "../../../../core/models/entities/LogoOptions";
import { useLogoContext } from "../contexts/logo-options.context";

export function useNumberPlaceholderLogoCreateViewModel(): NumberPlaceholderLogoCreate_VM {
  const { handleCreatePlaceholderNumberLogo, isLoading } =
    useLogoActionHandler();
  const { options } = useLogoContext();
  const { goToState } = useDesignEditorStateContext();
  const [transferMethod, setTransferMethod] = useState<TransferMethod>();
  const { design, addToDesign } = useDesignContext();
  const { generateNumberLogoPreview } = useLogoRepository();
  const [color, setColor] = useState<Color>();
  const [font, setFont] = useState<Font>();
  const [heightMM, setHeightMM] = useState<number>(0);

  function handleCancel() {
    // todo: confirmation dialog when leaving
    goToState(DesignEditorStates.Normal);
  }

  function handleAddLogo() {
    handleCreatePlaceholderNumberLogo(
      color?.id!,
      heightMM,
      font?.key!,
      transferMethod?.typeAndKey!,
      design.customerId
    ).then((logo) => {
      addToDesign(logo);
      goToState(DesignEditorStates.Normal);
    });
  }

  function isValid(): boolean {
    return !!color && !!font && !!heightMM && !!transferMethod && !isLoading;
  }

  function getPreview(
    color: Color,
    heightMM: number,
    font: Font
  ): Promise<string> {
    return generateNumberLogoPreview(
      color?.id!,
      heightMM,
      font?.key!,
      design.customerId
    );
  }

  return {
    font: font,
    onFontChange: setFont,
    heightMM: heightMM,
    onHeightMMChange: setHeightMM,
    color: color,
    onColorChange: setColor,
    options: options,
    transferMethod: transferMethod,
    setTransferMethod: setTransferMethod,
    onCancel: handleCancel,
    onAddLogo: handleAddLogo,
    canAdd: isValid(),
    getPreview: getPreview,
    isLoading: isLoading,
  };
}
